import { CountdownTimer } from "./CountdownTimer";
import { ArrowRight } from "lucide-react";

export const FoundersBanner = () => {
  return (
    <section data-testid="founders-banner" className="bg-[#0A192F] py-16 relative overflow-hidden">
      <div className="absolute inset-0 hero-grid opacity-20 pointer-events-none" />
      <div className="relative max-w-5xl mx-auto px-5 sm:px-8 text-center">
        <div className="inline-flex items-center gap-3 mb-6">
          <div className="gold-divider" />
          <span className="font-accent text-[#C5A059] text-xs">FOUNDER'S LAUNCH DISCOUNT</span>
          <div className="gold-divider" />
        </div>
        <h2 className="font-display text-3xl sm:text-5xl text-white mb-6 leading-tight">
          Save up to <span className="text-[#C5A059] italic">53%</span> &mdash; only during launch.
        </h2>
        <p className="text-white/70 max-w-2xl mx-auto mb-10">
          When the countdown ends, prices return to original. Lock in founder pricing today.
        </p>
        <div className="flex justify-center mb-10">
          <CountdownTimer />
        </div>
        <a
          href="#products"
          data-testid="banner-cta"
          className="inline-flex items-center gap-2 bg-[#C5A059] hover:bg-[#D4AF37] text-[#0A192F] font-bold px-7 py-4 text-sm transition"
        >
          CLAIM FOUNDER PRICING
          <ArrowRight className="w-4 h-4" />
        </a>
      </div>
    </section>
  );
};
